// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Date from "../Data.Date/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as DateUtils from "../DateUtils/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var decode = /* #__PURE__ */ Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode);
var pure = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var Day = function (x) {
    return x;
};
var toFillFormTypeDay = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("string");
    }
};
var showDay = Data_Date.showDate;
var ordDay = Data_Date.ordDate;
var newtypeDay_ = {
    Coercible0: function () {
        return undefined;
    }
};
var genericDay_ = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var eqDay = Data_Date.eqDate;
var udecodeDay = {
    unsafeDecode: function (value) {
        var str = Unscramble.decodeString(value);
        var v = DateUtils.parseISODate(str);
        if (v instanceof Data_Maybe.Just) {
            return v.value0;
        };
        if (v instanceof Data_Maybe.Nothing) {
            return Unscramble.decodingError("Invalid date");
        };
        throw new Error("Failed pattern match at Data.Day (line 44, column 7 - line 46, column 50): " + [ v.constructor.name ]);
    }
};
var fromDay = function (v) {
    return v;
};
var encodeDay = {
    encode: function (v) {
        return encode(DateUtils.formatISODate(v));
    }
};
var decodeDay = {
    decode: function (value) {
        return bind(decode(value))(function (str) {
            var v = DateUtils.parseISODate(str);
            if (v instanceof Data_Maybe.Just) {
                return pure(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid date"));
            };
            throw new Error("Failed pattern match at Data.Day (line 35, column 5 - line 37, column 56): " + [ v.constructor.name ]);
        });
    }
};
var dayDate = fromDay;
export {
    Day,
    dayDate,
    fromDay,
    genericDay_,
    newtypeDay_,
    eqDay,
    ordDay,
    showDay,
    decodeDay,
    udecodeDay,
    encodeDay,
    toFillFormTypeDay
};
